import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {Tabs} from 'antd';
import {FileTextOutlined} from '@ant-design/icons';

import PageTitle from '../../../components/page/PageTitle';
import ErrorBoundary from '../../../components/ErrorBoundary';
import AccountInvoices from '../../../components/invoicing/AccountInvoices';
import LegacyInvoices from '../../../components/invoicing/LegacyInvoices';
import {getAccountMembershipNumber, getActiveAccount} from '../../../lib/activeMember';

const InvoicesStaff = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // When staff did not set membership, display link to account change page
        if (getAccountMembershipNumber() == null || getActiveAccount() == null) {
            navigate('/member_change');
        }
    }, [navigate]);

    const tabsItems = [
        {
            label: 'Account Invoices',
            key: '1',
            children: (
                <ErrorBoundary>
                    <AccountInvoices/>
                </ErrorBoundary>
            ),
        },
        {
            label: 'Legacy Invoices',
            key: '2',
            children: (
                <ErrorBoundary>
                    <LegacyInvoices/>
                </ErrorBoundary>
            ),
        },
    ];

    return (
        getActiveAccount() !== null && (
            <>
                <PageTitle title="Invoices" icon={<FileTextOutlined/>}/>
                <Tabs defaultActiveKey="1" items={tabsItems.map(item => ({
                    label: item.label,
                    key: item.key,
                    children: item.children,
                }))}/>
            </>
        )
    );
};

export default InvoicesStaff;
